import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { KMS_DOCUMENT_TYPE_OPTIONS } from '~/app/components/kms/KmsUploadPanel/utils';

export const KMS_LIBRARY_STATUS_FILTER_VALUES = [
  'processing',
  'linked',
  'pending_review',
  'write_failed',
] as const;

export type KmsLibraryStatusFilter =
  (typeof KMS_LIBRARY_STATUS_FILTER_VALUES)[number];

export function useKmsLibraryFilterOptions() {
  const { t } = useTranslation('kms');

  const documentTypeOptions = useMemo(
    () =>
      KMS_DOCUMENT_TYPE_OPTIONS.map((option) => ({
        value: option.value,
        label: t(option.labelKey),
      })),
    [t],
  );

  const statusOptions = useMemo(
    () =>
      KMS_LIBRARY_STATUS_FILTER_VALUES.map((value) => ({
        value,
        label: t(`statusFilter.${value}`),
      })),
    [t],
  );

  return { documentTypeOptions, statusOptions };
}
